import React, { useState, useEffect } from 'react';
import { Table, Card, Button } from "reactstrap";
import { Link } from "react-router-dom";
import api, { FILE_BASE_URL } from '../../utils/api';

const LatestJournalists = () => {
    const [journalists, setJournalists] = useState([]);
    const [loading, setLoading] = useState(true);
    const [failedImages, setFailedImages] = useState(new Set());

    const formatDate = (dateString) => {
        if (!dateString) return 'غير محدد';
        
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    // دالة لإنشاء الدائرة الملونة
    const getAvatarCircle = (name) => {
        const firstLetter = name ? name.charAt(0).toUpperCase() : 'ص';
        
        return (
            <div 
                className="avatar-xs me-2 rounded-circle d-inline-flex align-items-center justify-content-center"
                style={{
                    backgroundColor: '#34c38f', // أخضر للصحفيين
                    color: '#ffffff',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    width: '30px',
                    height: '30px'
                }}
            >
                {firstLetter}
            </div>
        );
    };

    // دالة للحصول على الأفاتار (صورة أو دائرة)
    const getProfileAvatar = (journalist, index) => {
        const imageKey = `journalist-${journalist.id}-${index}`;
        
        // إذا فشلت الصورة مسبقاً، اعرض الدائرة مباشرة
        if (!journalist.profile_image || failedImages.has(imageKey)) {
            return getAvatarCircle(journalist.full_name);
        }

        // تحديد مسار الصورة الصحيح
        let imageSrc = '';
        if (journalist.profile_image.startsWith('http')) {
            imageSrc = journalist.profile_image;
        } else {
imageSrc = `${FILE_BASE_URL}/uploads/images/${journalist.profile_image}`;        }

        return (
            <img 
                src={imageSrc} 
                alt="user" 
                className="avatar-xs me-2 rounded-circle"
                onError={() => {
                    // أضف الصورة لقائمة الفاشلة
                    setFailedImages(prev => new Set([...prev, imageKey]));
                }}
            />
        );
    };

    const fetchJournalists = async () => {
try {
           setLoading(true);
           const response = await api.get("/journalists");
           const data = response.data.data || response.data || [];
            // أخذ آخر 6 صحفيين
            setJournalists(data.slice(0, 6));
        } catch (error) {
            console.error("خطأ في جلب الصحفيين:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchJournalists();
    }, []);

    if (loading) {
        return (
            <Card>
                <div className="card-body">
                    <h4 className="card-title mb-4">آخر الصحفيين</h4>
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">جاري التحميل...</span>
                        </div>
                    </div>
                </div>
            </Card>
        );
    }

    return (
        <Card>
            <div className="card-body">
                <h4 className="card-title mb-4">آخر الصحفيين</h4>

                <div className="table-responsive">
                    <Table className="align-middle table-centered table-vertical table-nowrap mb-1">
                        <tbody>
                            {journalists.length === 0 ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-4 text-muted">
                                        لا توجد بيانات لعرضها
                                    </td>
                                </tr>
                            ) : (
                                journalists.map((journalist, key) => (
                                    <tr key={key}>
                                        <td>
                                            {getProfileAvatar(journalist, key)}
                                            {journalist.full_name || 'غير محدد'}
                                        </td>
                                        <td>
                                            {formatDate(journalist.created_at)}
                                        </td>
                                        <td>
                                            <Link to={`/dashboard/journalists/edit/${journalist.id}`}>
                                                <Button 
                                                    color="secondary" 
                                                    size="sm" 
                                                    className="waves-effect waves-light"
                                                >
                                                    تعديل
                                                </Button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </Card>
    );
};

export default LatestJournalists;